import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getUserAccountRoleFromValue } from "../../../domain/user/account/UserAccountRole";
import { User } from "../../../domain/user/User";
import { UserEmail } from "../../../domain/user/UserEmail";
import { UserId } from "../../../domain/user/UserId";
import { UserName } from "../../../domain/user/UserName";
import { State } from "../../../state/store";

export const useAuthUser = (): User => {
    const { id, name, role, email } = useSelector((state: State) => state.auth);
    
    // 認証ユーザー情報の取得はRegistrationStatusProvider.tsxにて行う
    const user = useMemo(() => {
        return User.from(
            UserId.fromString(id),
            UserName.fromString(name),
            UserEmail.fromString(email),
            getUserAccountRoleFromValue(role),
        );
    }, [id, name, role, email]);

    return user;
};
